export var SearchCustomerMutationTypes;
(function (SearchCustomerMutationTypes) {
    SearchCustomerMutationTypes["INIT_STATE"] = "INIT_STATE";
    SearchCustomerMutationTypes["SET_SORT_TYPE"] = "SET_SORT_TYPE";
    SearchCustomerMutationTypes["SET_SEARCH_FORM"] = "SET_SEARCH_FORM";
    SearchCustomerMutationTypes["RESET_LIST"] = "RESET_LIST";
    SearchCustomerMutationTypes["SEARCH_CUSTOMERS"] = "SEARCH_CUSTOMERS";
})(SearchCustomerMutationTypes || (SearchCustomerMutationTypes = {}));
